import { render, staticRenderFns } from "./TaxonomyList.vue?vue&type=template&id=71af2b3a&"
import script from "./TaxonomyList.vue?vue&type=script&lang=js&"
export * from "./TaxonomyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports